import { CSSObject } from "@emotion/react";
import { constants, typographyStyles } from "@newsela/angelou";

const colors = constants.colors;

const black = colors.ui.black[500];
const coreBlue500 = colors.ui.core[500];
const neutral400 = colors.ui.neutral[400];
const neutral700 = colors.ui.neutral[700];
const white = colors.ui.white[500];

const WORD_COMPONENT_GRID_GAP = 22;

export const containerStylesCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  gap: "7px",
  padding: "16px",
  backgroundColor: white,
};

export const wordSectionCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  padding: "0 7px",
};

export const targetWordAndArmsCss: CSSObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
  position: "relative",
};

const armContainerCss: CSSObject = {
  position: "relative",
  flex: 1,
  display: "flex",
  alignItems: "flex-end",
  top: "20px",
};

export const leftArmContainerCss: CSSObject = {
  ...armContainerCss,
  justifyContent: "flex-end",
};

export const rightArmContainerCss: CSSObject = {
  ...armContainerCss,
  justifyContent: "flex-start",
};

export const wordAndArrowContainerCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export const targetWordAndArrowContainerCss: CSSObject = {
  ...wordAndArrowContainerCss,
  width: `calc(calc(100% - ${WORD_COMPONENT_GRID_GAP * 2}px) / 3)`,
};

const textAreaContainerCss: CSSObject = {
  ...typographyStyles.textMObj,
  width: "100%",
  padding: "7px 14px",
  border: `4px solid ${coreBlue500}`,
  borderRadius: "32px",
  color: neutral700,
  backgroundColor: white,
  display: "flex",
  flexDirection: "column",
};

export const targetWordContainerCss: CSSObject = {
  ...textAreaContainerCss,
  alignItems: "center",
};

export const wordContainerCss: CSSObject = {
  ...textAreaContainerCss,
  alignItems: "flex-start",
  "> * + *": {
    marginTop: 2,
  },
};

export const wordHeaderStylesCss: CSSObject = {
  ...typographyStyles.heading5Obj,
  fontWeight: 700,
  marginBottom: "4px",
};

export const wordInputStylesCss: CSSObject = {
  ...typographyStyles.textMObj,
  padding: "6px 16px",
  width: "100%",
  height: "36px",
  resize: "none",
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  backgroundColor: "transparent",
  fontWeight: "normal",
};

export const wordComponentsGridCss: CSSObject = {
  display: "flex",
  gap: WORD_COMPONENT_GRID_GAP,
  "> *": {
    flex: 1,
  },
};

export const wordComponentColumnCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
};

export const wordComponentRowCss: CSSObject = {
  display: "flex",
  justifyContent: "space-between",
};

export const wordComponentLabelCss: CSSObject = {
  fontSize: "14px",
  lineHeight: "114%",
  color: black,
  fontWeight: 600,
  whiteSpace: "nowrap",
  marginBottom: "2px",
};

export const wordComponentInputCss: CSSObject = {
  ...typographyStyles.textSObj,
  padding: "16px 8px",
  width: "100%",
  height: 32,
  margin: "0",
  border: `1px solid ${neutral400}`,
  borderRadius: "8px",
  fontWeight: "normal",
  textAlign: "left",

  "&:disabled": {
    color: "inherit",
  },
};

export const exampleTextAreaContainerCss: CSSObject = {
  ...textAreaContainerCss,
};

export const exampleLabelCss: CSSObject = {
  ...typographyStyles.textMObj,
  minWidth: "112px",
  maxWidth: "112px",
  color: black,
  fontWeight: 600,
  marginRight: "14px",
};

export const exampleTextareaCss: CSSObject = {
  width: "100%",
  height: "66px",
};

export const arrowLineLeftCss: CSSObject = {
  position: "relative",
  // Account for the arrow tip width
  width: "calc(100% / 2 + 12.64px)",
  height: "66px",
  border: `3px solid ${coreBlue500}`,
  borderBottom: "none",
  borderRight: "none",
  borderTopLeftRadius: "12px",

  "&:before, :after": {
    content: '""',
    position: "absolute",
    left: "-3px",
    bottom: "-3px",
    width: "3px",
    height: "17px",
    backgroundColor: coreBlue500,
    borderRadius: "999px",
    transformOrigin: "center",
  },
  "&:before": {
    transform: "translateX(-5px)  rotate(-45deg)",
  },
  "&:after": {
    transform: "translateX(5px) rotate(45deg)",
  },
};

export const arrowLineRightCss: CSSObject = {
  transform: "scaleX(-1)",
};

export const arrowDownShaftCss: CSSObject = {
  width: "3px",
  height: "20px",
  background: coreBlue500,
  position: "relative",
  borderRadius: "0 0 999px 999px",

  "&:before, :after": {
    content: '""',
    position: "absolute",
    left: 0,
    bottom: "-3px",
    width: "3px",
    height: "17px",
    backgroundColor: coreBlue500,
    borderRadius: "999px",
    transformOrigin: "center",
  },
  "&:before": {
    transform: "translateX(-5px)  rotate(-45deg)",
  },
  "&:after": {
    transform: "translateX(5px) rotate(45deg)",
  },
};
